<template>
  <v-container>
    <step-buttons-therapy
      class="my-2"
      is-last-step
      :show-save-button="canSaveToS3"
      :is-saving="isSavingToS3"
      :can-save="canSaveToS3"
      :disabled-next="isFinishing"
      :is-finishing="isFinishing"
      @click-next="submit"
      @click-back="back"
      @click-save="$emit('save-to-s3')"
    />
    <therapy-card title="Revisão do Diagnóstico">
      <div>
        <label-icon icon="person" label="Paciente" bold>
          {{ patient.name }}
        </label-icon>
        <v-divider class="my-5" />

        <pares-section />

        <tumoral-phenomena-section />

        <vascular-phenomena-section />

        <potential-spaces-section />

        <flow-types-section />

        <oligoelements-section />

        <chakras-section />

        <chromosomes-section />

        <complementary-therapies-section />

        <v-divider class="my-5" />
        <label-icon icon="mode_comment" label="Comentários" bold />

        <v-textarea
          v-model="therapistComments"
          class="mt-3 text-area-custom"
          label="Comentários do terapeuta"
          placeholder="Informações adicionais (Protocolos, técnicas, procedimentos realizadas antes da terapia, exames complementares, comentários, etc). Este campo não será mostrado ao paciente."
          persistent-placeholder
          outlined
          rows="3"
        />
        <v-textarea
          v-model="patientComments"
          label="Comentários ao paciente"
          placeholder="Comentários gerais ao paciente (mostrado ao paciente)"
          persistent-placeholder
          outlined
          rows="3"
        />
      </div>

      <!-- File Upload Section -->
      <v-divider class="my-4"></v-divider>
      <v-row class="mb-4">
        <v-col cols="12">
          <multiple-input-file
            v-model="additionalFiles"
            label="Arquivos anexados"
            input-accept="image/*,application/pdf"
          ></multiple-input-file>
        </v-col>
      </v-row>
    </therapy-card>
    <step-buttons-therapy
      class="my-5"
      is-last-step
      :show-save-button="canSaveToS3"
      :is-saving="isSavingToS3"
      :can-save="canSaveToS3"
      :disabled-next="isFinishing"
      :is-finishing="isFinishing"
      @click-next="submit"
      @click-back="back"
      @click-save="$emit('save-to-s3')"
    />
  </v-container>
</template>

<script>
export default {
  components: {
    TumoralPhenomenaSection: () => import("./TumoralPhenomenaSection"),
    VascularPhenomenaSection: () => import("./VascularPhenomenaSection"),
    ParesSection: () => import("./ParesSection"),
    PotentialSpacesSection: () => import("./PotentialSpacesSection"),
    FlowTypesSection: () => import("./FlowTypesSection"),
    OligoelementsSection: () => import("./OligoelementsSection"),
    ChakrasSection: () => import("./ChakrasSection"),
    ChromosomesSection: () => import("./ChromosomesSection"),
    ComplementaryTherapiesSection: () =>
      import("./ComplementaryTherapiesSection"),
  },
  props: {
    isSavingToS3: {
      type: Boolean,
      default: false,
    },
    canSaveToS3: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFinishing: false,
    };
  },
  computed: {
    therapistComments: {
      get() {
        return this.$store.state.diagnosis.diagnose?.therapistComments || "";
      },
      set(value) {
        this.$store.commit("diagnosis/setTherapistComments", value);
      },
    },
    patientComments: {
      get() {
        return this.$store.state.diagnosis.diagnose?.patientComments || "";
      },
      set(value) {
        this.$store.commit("diagnosis/setPatientComments", value);
      },
    },
    patient() {
      return this.$store.getters["therapy/patient"];
    },
    additionalFiles: {
      get() {
        return this.$store.state.therapy.therapy.additionalFiles;
      },
      set(newValue) {
        // 🔥 FIX: Faz upload eager para que os arquivos sejam persistidos no backup S3
        this.$store.dispatch("therapy/uploadAdditionalFiles", newValue);
      },
    },
  },
  methods: {
    back() {
      this.$emit("back");
    },
    async submit() {
      try {
        this.isFinishing = true;

        // Abre dialog de loading global
        this.$store.dispatch("loading/openDialog");

        // Exibe toast informativo
        const toastId = this.$toasted.info("Finalizando terapia, aguarde...", {
          duration: null, // Não fecha automaticamente
        });

        await this.$store.dispatch("therapy/finish");

        // Fecha o loading global
        this.$store.dispatch("loading/closeDialog");

        // Fecha o toast de loading
        if (toastId) {
          toastId.goAway(0);
        }

        // Exibe mensagem de sucesso
        this.$toasted.success("Terapia finalizada com sucesso!", {
          duration: 3000,
        });

        this.$router.push({ name: "therapys" });
      } catch (error) {
        this.isFinishing = false;

        // Fecha o loading global
        this.$store.dispatch("loading/closeDialog");

        console.error("[Finish] Erro ao finalizar terapia:", error);
        this.$toasted.error("Erro ao finalizar terapia. Tente novamente.", {
          duration: 5000,
        });
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped></style>
